const prefix = 'shared/';

export const OPEN_DELETING_DIALOG = `${prefix}OPEN_DELETING_DIALOG`;
export const CLOSE_DELETING_DIALOG = `${prefix}CLOSE_DELETING_DIALOG`;
